// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-billing-page {
  display: grid;
  gap: 1.25rem;
}

.plan-billing-loading,
.plan-billing-error,
.plan-billing-empty {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  min-height: 14rem;
  padding: 2rem 1rem;
  text-align: center;
}

.plan-billing-error a {
  margin-top: 0.5rem;
}

.plan-billing-summary-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.plan-billing-summary-card,
.plan-billing-section {
  background: var(--color-bg, #fff);
  border: 1px solid color-mix(in srgb, currentColor 14%, transparent);
  border-radius: 0.75rem;
  box-sizing: border-box;
  padding: 1.25rem;
}

.plan-billing-eyebrow {
  color: #66736d;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin: 0 0 0.35rem;
  text-transform: uppercase;
}

.plan-billing-card-title,
.plan-billing-section-heading,
.plan-billing-pagination {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.plan-billing-card-title h2,
.plan-billing-section-heading h2 {
  margin: 0;
}

.plan-billing-summary-card dl {
  display: grid;
  gap: 0.75rem;
  margin: 1.25rem 0 0;
}

.plan-billing-summary-card dl > div {
  align-items: baseline;
  border-top: 1px solid color-mix(in srgb, currentColor 10%, transparent);
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding-top: 0.75rem;
}

.plan-billing-summary-card dt {
  color: #66736d;
}

.plan-billing-summary-card dd {
  font-weight: 600;
  margin: 0;
  text-align: right;
}

.plan-billing-status {
  background: #edf0ef;
  border-radius: 999px;
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.25rem 0.65rem;
  text-transform: capitalize;
  white-space: nowrap;
}

.plan-billing-status.active,
.plan-billing-status.settled {
  background: #dff5e7;
  color: #185c32;
}

.plan-billing-status.expired,
.plan-billing-status.trial-expired,
.plan-billing-status.needs-review {
  background: #ffe1dc;
  color: #8b2418;
}

.plan-billing-status.cancelled,
.plan-billing-status.suspended,
.plan-billing-status.shadow {
  background: #f8e8d0;
  color: #704512;
}

.plan-billing-action-row {
  margin: 1.25rem 0 0;
}

.plan-billing-action-row .button,
.plan-billing-pagination .button,
.plan-billing-error .button {
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  min-height: 44px;
}

.plan-billing-history-note {
  background: color-mix(in srgb, #e6a700 12%, transparent);
  border-left: 4px solid #ad6000;
  margin: 0;
  padding: 0.9rem 1rem;
}

.plan-billing-transactions {
  display: grid;
  gap: 0.75rem;
  margin-top: 1rem;
}

.plan-billing-transaction {
  align-items: center;
  border: 1px solid color-mix(in srgb, currentColor 12%, transparent);
  border-radius: 0.6rem;
  display: grid;
  gap: 0.75rem 1rem;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 1rem;
}

.plan-billing-transaction h3,
.plan-billing-transaction p {
  margin: 0;
}

.plan-billing-transaction p,
.plan-billing-transaction code {
  color: #66736d;
  font-size: 0.85rem;
}

.plan-billing-transaction code {
  grid-column: 1 / -1;
  overflow-wrap: anywhere;
}

.plan-billing-transaction-amount {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.plan-billing-comparison-scroll {
  margin-top: 1rem;
  overflow-x: auto;
}

.plan-billing-comparison-table {
  border-collapse: collapse;
  min-width: 100%;
  width: 100%;
}

.plan-billing-comparison-table th,
.plan-billing-comparison-table td {
  border-bottom: 1px solid color-mix(in srgb, currentColor 10%, transparent);
  padding: 0.75rem;
  text-align: center;
  vertical-align: top;
  white-space: nowrap;
}

.plan-billing-comparison-table tbody th {
  background: var(--color-bg, #fff);
  left: 0;
  position: sticky;
  text-align: left;
  white-space: normal;
}

.plan-billing-comparison-feature-header {
  left: 0;
  position: sticky;
}

.plan-billing-comparison-table thead th {
  min-width: 9rem;
}

.plan-billing-comparison-table h3 {
  font-size: 1rem;
  margin: 0 0 0.5rem;
}

.plan-billing-tier-price {
  display: grid;
  gap: 0.15rem;
  margin-bottom: 0.5rem;
}

.plan-billing-tier-price strong {
  font-size: 1.1rem;
}

.plan-billing-tier-price small {
  color: #66736d;
}

.plan-billing-tier-price .button {
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin-top: 0.35rem;
  min-height: 44px;
}

.plan-billing-tier-included,
.plan-billing-unavailable {
  color: #66736d;
  font-size: 0.85rem;
  white-space: normal;
}

.plan-billing-cell-included {
  color: #185c32;
}

.plan-billing-cell-not-included {
  color: #8b2418;
}

.plan-billing-cell-empty {
  color: #66736d;
}

.plan-billing-pagination {
  margin-top: 1rem;
}

@media (max-width: 760px) {
  .plan-billing-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .plan-billing-section-heading {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 420px) {
  .plan-billing-summary-grid,
  .plan-billing-transaction {
    grid-template-columns: minmax(0, 1fr);
  }

  .plan-billing-summary-card,
  .plan-billing-section {
    padding: 1rem;
  }

  .plan-billing-card-title,
  .plan-billing-pagination,
  .plan-billing-summary-card dl > div {
    align-items: flex-start;
    flex-direction: column;
  }

  .plan-billing-summary-card dd {
    text-align: left;
  }

  .plan-billing-transaction-amount {
    align-items: flex-start;
  }

  .plan-billing-pagination .button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Billing/PlanBillingPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;;EAEE,iCAAiC;EACjC,mEAAmE;EACnE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uEAAuE;EACvE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mEAAmE;EACnE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,0EAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".plan-billing-page {\n  display: grid;\n  gap: 1.25rem;\n}\n\n.plan-billing-loading,\n.plan-billing-error,\n.plan-billing-empty {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  justify-content: center;\n  min-height: 14rem;\n  padding: 2rem 1rem;\n  text-align: center;\n}\n\n.plan-billing-error a {\n  margin-top: 0.5rem;\n}\n\n.plan-billing-summary-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.plan-billing-summary-card,\n.plan-billing-section {\n  background: var(--color-bg, #fff);\n  border: 1px solid color-mix(in srgb, currentColor 14%, transparent);\n  border-radius: 0.75rem;\n  box-sizing: border-box;\n  padding: 1.25rem;\n}\n\n.plan-billing-eyebrow {\n  color: #66736d;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin: 0 0 0.35rem;\n  text-transform: uppercase;\n}\n\n.plan-billing-card-title,\n.plan-billing-section-heading,\n.plan-billing-pagination {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n}\n\n.plan-billing-card-title h2,\n.plan-billing-section-heading h2 {\n  margin: 0;\n}\n\n.plan-billing-summary-card dl {\n  display: grid;\n  gap: 0.75rem;\n  margin: 1.25rem 0 0;\n}\n\n.plan-billing-summary-card dl > div {\n  align-items: baseline;\n  border-top: 1px solid color-mix(in srgb, currentColor 10%, transparent);\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  padding-top: 0.75rem;\n}\n\n.plan-billing-summary-card dt {\n  color: #66736d;\n}\n\n.plan-billing-summary-card dd {\n  font-weight: 600;\n  margin: 0;\n  text-align: right;\n}\n\n.plan-billing-status {\n  background: #edf0ef;\n  border-radius: 999px;\n  display: inline-block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.25rem 0.65rem;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n\n.plan-billing-status.active,\n.plan-billing-status.settled {\n  background: #dff5e7;\n  color: #185c32;\n}\n\n.plan-billing-status.expired,\n.plan-billing-status.trial-expired,\n.plan-billing-status.needs-review {\n  background: #ffe1dc;\n  color: #8b2418;\n}\n\n.plan-billing-status.cancelled,\n.plan-billing-status.suspended,\n.plan-billing-status.shadow {\n  background: #f8e8d0;\n  color: #704512;\n}\n\n.plan-billing-action-row {\n  margin: 1.25rem 0 0;\n}\n\n.plan-billing-action-row .button,\n.plan-billing-pagination .button,\n.plan-billing-error .button {\n  align-items: center;\n  box-sizing: border-box;\n  display: inline-flex;\n  justify-content: center;\n  min-height: 44px;\n}\n\n.plan-billing-history-note {\n  background: color-mix(in srgb, #e6a700 12%, transparent);\n  border-left: 4px solid #ad6000;\n  margin: 0;\n  padding: 0.9rem 1rem;\n}\n\n.plan-billing-transactions {\n  display: grid;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.plan-billing-transaction {\n  align-items: center;\n  border: 1px solid color-mix(in srgb, currentColor 12%, transparent);\n  border-radius: 0.6rem;\n  display: grid;\n  gap: 0.75rem 1rem;\n  grid-template-columns: minmax(0, 1fr) auto;\n  padding: 1rem;\n}\n\n.plan-billing-transaction h3,\n.plan-billing-transaction p {\n  margin: 0;\n}\n\n.plan-billing-transaction p,\n.plan-billing-transaction code {\n  color: #66736d;\n  font-size: 0.85rem;\n}\n\n.plan-billing-transaction code {\n  grid-column: 1 / -1;\n  overflow-wrap: anywhere;\n}\n\n.plan-billing-transaction-amount {\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.plan-billing-comparison-scroll {\n  margin-top: 1rem;\n  overflow-x: auto;\n}\n\n.plan-billing-comparison-table {\n  border-collapse: collapse;\n  min-width: 100%;\n  width: 100%;\n}\n\n.plan-billing-comparison-table th,\n.plan-billing-comparison-table td {\n  border-bottom: 1px solid color-mix(in srgb, currentColor 10%, transparent);\n  padding: 0.75rem;\n  text-align: center;\n  vertical-align: top;\n  white-space: nowrap;\n}\n\n.plan-billing-comparison-table tbody th {\n  background: var(--color-bg, #fff);\n  left: 0;\n  position: sticky;\n  text-align: left;\n  white-space: normal;\n}\n\n.plan-billing-comparison-feature-header {\n  left: 0;\n  position: sticky;\n}\n\n.plan-billing-comparison-table thead th {\n  min-width: 9rem;\n}\n\n.plan-billing-comparison-table h3 {\n  font-size: 1rem;\n  margin: 0 0 0.5rem;\n}\n\n.plan-billing-tier-price {\n  display: grid;\n  gap: 0.15rem;\n  margin-bottom: 0.5rem;\n}\n\n.plan-billing-tier-price strong {\n  font-size: 1.1rem;\n}\n\n.plan-billing-tier-price small {\n  color: #66736d;\n}\n\n.plan-billing-tier-price .button {\n  align-items: center;\n  box-sizing: border-box;\n  display: inline-flex;\n  justify-content: center;\n  margin-top: 0.35rem;\n  min-height: 44px;\n}\n\n.plan-billing-tier-included,\n.plan-billing-unavailable {\n  color: #66736d;\n  font-size: 0.85rem;\n  white-space: normal;\n}\n\n.plan-billing-cell-included {\n  color: #185c32;\n}\n\n.plan-billing-cell-not-included {\n  color: #8b2418;\n}\n\n.plan-billing-cell-empty {\n  color: #66736d;\n}\n\n.plan-billing-pagination {\n  margin-top: 1rem;\n}\n\n@media (max-width: 760px) {\n  .plan-billing-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .plan-billing-section-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 420px) {\n  .plan-billing-summary-grid,\n  .plan-billing-transaction {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .plan-billing-summary-card,\n  .plan-billing-section {\n    padding: 1rem;\n  }\n\n  .plan-billing-card-title,\n  .plan-billing-pagination,\n  .plan-billing-summary-card dl > div {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .plan-billing-summary-card dd {\n    text-align: left;\n  }\n\n  .plan-billing-transaction-amount {\n    align-items: flex-start;\n  }\n\n  .plan-billing-pagination .button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
